import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"home-door, house"} maskId="square-filled-radius-0-stroke-1-IconHomeDoor"><path fillRule="evenodd" clipRule="evenodd" d="M21 8.60336L12 1.3584L3 8.60336V21.0003H21V8.60336ZM8 12V21H9V13H15V21H16V12H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHomeDoor;
